import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private cookies : CookieService, private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> 
    {
        if (req.headers.get('No-Auth') == "True")
            return next.handle(req.clone({headers:req.headers.set('api-version', '1')}));

        // Add bearer token here rather than explicitly doing it in every service call we make :) DRY!!!
        if (this.cookies.get('authToken') != '') 
        {
            const clonedreq = req.clone({
                headers: req.headers
                    .set("Authorization", "Bearer " + this.cookies.get('authToken'))
                    .set('api-version', '1')
                    .set('Access-Control-Allow-Credentials','true'),
                withCredentials: true,
                params: req.params
            });

            return next.handle(clonedreq).pipe(
                tap(
                succ => { },
                err => {
                    if (err.status === 401)
                        this.router.navigateByUrl('/login');
                    console.log(clonedreq);
                    console.log(err);
                    }
                ));
        }
        else 
        {
            this.router.navigateByUrl('/login');
        }
    }
}
